import React from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';
import { useGlobalStore } from 'store';

import * as Styled from './UnsupportedBrowser.styles';

interface UnsupportedBrowserProps {
  setAccept(state: boolean): void;
}

const UnsupportedBrowserProps = ({ setAccept }) => {
  const { isError } = useGlobalStore();

  return (
    isError && (
      <Styled.Wrapper>
        <ErrorScreen
          errorType="unsupportedBrowser"
          handleContinueAnyway={setAccept}
        />
      </Styled.Wrapper>
    )
  );
};

export default UnsupportedBrowserProps;
